<template>
	<div class="mb-3 acountinfo d-flex align-items-center justify-content-between" v-if="Object.keys(accountDetails).length > 0 ">
		<div class="acountinfobox whiteBG radiusbold ">
			<small>{{$t('balance')}}</small>
			<h3 v-html="(accountDetails != '' && accountDetails.margin_detail != '')? accountDetails.margin_detail.balance : '0'"></h3>
		</div>
		<div class="acountinfobox whiteBG radiusbold ">
			<small>{{$t('margin')}}</small>
			<h3 v-html="(accountDetails != '' && accountDetails.margin_detail != '')? accountDetails.margin_detail.margin : '0'"></h3>
		</div>
		<div class="acountinfobox whiteBG radiusbold ">
			<small>{{$t('equity')}}</small>
			<h3 v-html="(accountDetails != '' && accountDetails.margin_detail != '')? accountDetails.margin_detail.equity : '0'"></h3>
		</div>
		<div class="acountinfobox whiteBG radiusbold ">
			<small>{{$t('PL')}}</small>
			<h3>0</h3>
		</div>
		
		<div class="tradeNowBtn" v-if="lastSelectTradingAccount != ''">
			<router-link :to="'/new-web-trade-link'" v-if="(lastSelectTradingAccount != '') && (lastSelectTradingAccount[0].platform == 'MT4')" target="_blank">
				{{$t('tradeNow')}}
			</router-link>
			<router-link :to="{path : '/web-trade-link',query : {'platform' : lastSelectTradingAccount[0].platform}}" v-if="(lastSelectTradingAccount != '') && (lastSelectTradingAccount[0].platform == 'MT5')" target="_blank">
				{{$t('tradeNow')}}
			</router-link>
			<a href="http://demo.actforex.sysfx.com:8100/trade/actlite.jsp?entry=demo.245" target="_blank" v-if="lastSelectTradingAccount != '' && lastSelectTradingAccount[0].platform == 'ACT' && parseInt(lastSelectTradingAccount[0].demo_live) == 0"> {{$t('tradeNow')}}</a>
			<a href="http://live.actforex.sysfx.com:8100/trade/actlite.jsp?entry=deal.245" target="_blank" v-if="lastSelectTradingAccount != '' && lastSelectTradingAccount[0].platform == 'ACT' && parseInt(lastSelectTradingAccount[0].demo_live) == 1"> {{$t('tradeNow')}}</a> 
		</div>
	</div>
</template>
<script>	
    import { fxViewMixins } from '@/plugins/fxView'
    import i18n from '@/plugins/lang/i18n';
    export default {
        name: 'Dashboard',
		mixins: [fxViewMixins],
        data() {
            return {
  				showStepComponent : false,
  				showTradingAccountModal : false,
				platformIcon : {'MT4' : 'platforn-icon-1.svg' , 'MT5' : 'platforn-icon-3.svg','ACT' : 'platforn-icon-2.svg'},
				liveDemoIcon : {'0' :'Demo' , '1' :'Live',0: 'Demo' ,1: 'live'}
  			}
        },
        methods:{
            getCurrentSteps(){
				let currentStep = this.get_user.step
				if('tempStep' in this.get_user && currentStep < this.get_user.tempStep){
				currentStep = this.get_user.tempStep
				}
				this.userStep = currentStep
				return currentStep
            } 
        },
        created(){ }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingAccounts/balance_margin_section.vue